import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'gauge',
  name_en: 'Gauge',
  // name_zh: '仪表盘',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    data: amount => amount > 1
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends StandardChartLayerSpec {
  encoding: {
    x: string;
  };
}

export const gauge = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { data: dataArray, hook: hooks, layout } = api;
    const presetOption = hooks.buildStandardChartPresetOption(api);
    const {
      dataIndex = 0,
      encoding: { x }
    } = spec;
    const data = dataArray[dataIndex];
    const dataMetaInfo = hooks.parseDataMetaInfo(data);

    // * ------------------------- data
    const gaugeValue = hooks.formatDataNumberValue(+data.values[0][x], {
      type: 'table',
      unit: dataMetaInfo[x]?.unit
    }).value;
    const l = gaugeValue.toString().split('.')[0].length;
    const lValue = 10 ** (l - 1);
    const lowerBound = Math.floor(gaugeValue / lValue) * lValue;
    const upperBound = lowerBound + lValue;
    const isLargeLayout = layout.includes('lg');

    // * ------------------------- chart
    return {
      legend: {
        data: []
      },
      xAxis: [],
      yAxis: [],
      series: [
        {
          type: 'gauge',
          radius: '100%',
          center: ['50%', '57%'],
          axisLine: {
            lineStyle: {
              width: isLargeLayout ? 30 : 20,
              color: [
                [0.3, presetOption?.color[0] || '#67e0e3'],
                [0.7, presetOption?.color[1] || '#37a2da'],
                [1, presetOption?.color[2] || '#fd666d']
              ]
            }
          },
          title: {
            show: true
          },
          pointer: {
            show: true
          },
          axisTick: {
            show: true,
            distance: isLargeLayout ? -30 : -20
          },
          splitLine: {
            show: true,
            distance: isLargeLayout ? -30 : -20
          },
          axisLabel: {
            color: 'inherit',
            distance: isLargeLayout ? 40 : 20,
            fontSize: isLargeLayout ? 20 : 12
          },
          detail: {
            show: true,
            valueAnimation: true,
            // formatter: "{value} km/h",
            color: 'inherit',
            borderWidth: 0,
            fontSize: isLargeLayout ? 30 : 20
          },
          min: lowerBound,
          max: upperBound,
          data: [
            {
              name: `${x}${
                hooks.formatDataNumberValue(+data.values[0][x]).unit
                  ? `(${hooks.formatDataNumberValue(+data.values[0][x]).unit})`
                  : ''
              }`,
              value: gaugeValue
            }
          ]
        }
      ]
    };
  }
});
